import {usersAdapter} from "../slices/users";

export const {
    selectById: userById,
    selectAll: usersAll,
} = usersAdapter.getSelectors((state: any)=> state.users);
